<template>
  <div>
  	<a :href="imageUrl" target="_blank" style="text-decoration: none;">
      <img :src="imageUrl" width="600" height="" :alt="imageAlt" border="0" style="width: 100%; max-width: 600px; height: auto; font-family: sans-serif; font-size: 15px; line-height: 15px; color: #555555; margin: auto; display: block;" class="g-img" />
    </a>
  </div>
</template>
<script>
  export default {
    props: {
      organization: Object,
      block: Object,
      recipient: Object,
      placeholders: Object,
    },
    data() {
      return {
        trans: trans,
        image_url2: null,
      }
    },
    computed: {
      imageUrl() {
        return this.image_url2 || this.block.image_url || '/img/frontend/blocks/1200x600.png'
      },
      imageAlt() {
        return this.block.image_alt || ''
      },
    },
    watch: {
      placeholders() {
        this.refreshPreview()
      },
    },
    methods: {
      refreshPreview() {
        this.image_url2 = null
        if (!this.block.paper_id || !this.placeholders || !this.recipient) return
        let url = `/organization/${this.organization.id}/paper/${this.block.paper_id}/image/recipient/${this.recipient.id}`
        axios.post(url)
        .then(response => {
          this.image_url2 = response.data.url
        })
        .catch(error => {

        })
      },
    },
    mounted() {
      window['paperBlock'+(this.block ? this.block.id || '' : '')] = this
    },
  }
</script>